import React from 'react';
import { Typography } from '@mui/material';

const HeaderViewDocument = () => {
  return <Typography variant="h2">Visualização Documento</Typography>;
};

export default HeaderViewDocument;
